<template>
    <div></div>
</template>

<script>
// @ is an alias to /src
import helper from '../helper'
export default {
  name: 'Logout',
  created(){
    localStorage.removeItem('access_token')
    helper.clearUserConnectedCookie()
  },
  mounted(){
    window.mixpanel.track("logout");
    localStorage.removeItem('access_token')
    helper.clearUserConnectedCookie()
  }
}
</script>
